export const bookMarkEventsTracking = {
	HOMEPAGE_CLICK_BOOKMARK_SUCCESS: 'HOMEPAGE_CLICK_BOOKMARK_SUCCESS', //order
	POPULAR_CITY_CLICK_BOOKMARK_SUCCESS: 'POPULAR_CITY_CLICK_BOOKMARK_SUCCESS', //order_city
	SEE_MORE_JOBS_CLICK_BOOKMARK_SUCCESS: 'SEE_MORE_JOBS_CLICK_BOOKMARK_SUCCESS', //order
	FIND_JOB_CLICK_BOOKMARK_SUCCESS: 'FIND_JOB_CLICK_BOOKMARK_SUCCESS', //order
	JOB_DETAIL_CLICK_BOOKMARK_SUCCESS: 'JOB_DETAIL_CLICK_BOOKMARK_SUCCESS',
	FIND_JOB_RESULTS_CLICK_BOOKMARK_SUCCESS: 'FIND_JOB_RESULTS_CLICK_BOOKMARK_SUCCESS', //order
	FAVOURITE_TAB_CLICK_BOOKMARK_SUCCESS: 'FAVOURITE_TAB_CLICK_BOOKMARK_SUCCESS',
}
